<template>
  <div class="form-header">
    <div class="logos-container">
      <img src="@/assets/img-colsubsidio.jpeg" alt="Colsubsidio" class="logo-izquierda" />
    </div>
    <div class="header-section">
      <h1 class="title-banner">Diagnóstico digital de entorno laboral</h1>
      <div class="descripcion-diagnostico">
        <p>La gestión estratégica del talento humano es un pilar fundamental para garantizar la
          sostenibilidad, competitividad e innovación de las organizaciones. En este contexto, las
          actividades para la gestión del talento se convierten en un aspecto clave para alinear la
          planeación de personas con las metas del negocio.</p>
        
        <p>Con este <strong>Diagnóstico digital de entorno laboral y los 5 pilares de análisis</strong>, se busca
          ofrecer una herramienta práctica y estructurada que permita por un lado, identificar brechas
          en políticas, procesos y prácticas de gestión que impacten la atracción, desarrollo y
          retención del capital humano; además de evaluar la efectividad en la estructuración de
          vacantes tácticas y estratégicas.</p>
        
        <p>Este diagnóstico no constituye una evaluación de personas, sino un <strong>instrumento de
          autogestión para la empresa</strong>. No debe interpretarse como un análisis profundo y detallado
          de la situación actual de la compañía, es un ejercicio orientativo.</p>
      </div>
    </div>
    <div class="pilares-analisis">
      <h3 class="primary-title">Pilares de análisis</h3>
      <ul>
        <li v-for="categoria in categorias" :key="categoria.id">
          <div>
            <strong>{{ categoria.name || categoria.title || categoria.nombre }}</strong>
            <p>{{ categoria.short_description || categoria.descripcion || categoria.desc }}</p>
          </div>
          <div class="peso-categoria">{{ categoria.weight || categoria.peso || 20 }}%</div>
        </li>
        
        <!-- Fallback en caso de que no haya categorías cargadas -->
        <li v-if="!categorias || categorias.length === 0">
          <strong>Perfil competitivo: 20%</strong>
          <p>Barreras y facilitadores en los procesos de convocatoria, atracción, selección y retención del talento</p>
        </li>
        <li v-if="!categorias || categorias.length === 0">
          <strong>Servicios, sistemas y políticas: 20%</strong>
          <p>Evaluación de la normatividad, políticas que promueven los procesos de selección y retención</p>
        </li>
        <li v-if="!categorias || categorias.length === 0">
          <strong>Marca Empleadora: 20%</strong>
          <p>Identificación de rasgos y comportamientos de la cultura organizacional y su impacto en la empresa</p>
        </li>
        <li v-if="!categorias || categorias.length === 0">
          <strong>Tecnologías y Herramientas: 20%</strong>
          <p>Recursos tecnológicos, capacidad de innovación y adaptación a los cambios y demanda del mercado</p>
        </li>
        <li v-if="!categorias || categorias.length === 0">
          <strong>Actualización de conocimiento y upskilling: 20%</strong>
          <p>Necesidades de formación y actualización en conocimiento del equipo de trabajo</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DiagnosticDescription',
  props: {
    categorias: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style scoped>
.logos-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 4rem;
  background-color: #2D2D2D;
}

.logo-izquierda,
.logo-derecha {
  max-height: 60px;
  width: auto;
  object-fit: contain;
}

/* Responsive para tablets */
@media (max-width: 768px) {
  .logos-container {
    padding: 1rem 2rem;
  }

  .logo-izquierda,
  .logo-derecha {
    max-height: 50px;
  }
}

/* Responsive para móviles */
@media (max-width: 480px) {
  .logos-container {
    padding: 0.75rem 1rem;
  }

  .logo-izquierda,
  .logo-derecha {
    max-height: 1.625rem; /* equivalente a 26px */
  }
}

.header-section {
  background-color: #2D2D2D;
  padding: 2rem;
}

.title-banner {
  color: #FFD000;
  padding: 1rem 0;
  text-align: center;
  margin-bottom: 1.5rem;
  font-size: 3.5rem;
  margin-top: 0;
}

@media (max-width: 768px) {
  .title-banner {
    font-size: 2.5rem;
    padding: 0.75rem 0;
    margin-bottom: 1rem;
  }
}

@media (max-width: 480px) {
  .title-banner {
    font-size: 2.2rem;
    padding: 0.5rem 0;
    margin-bottom: 0.75rem;
    line-height: 1.2;
  }
}

.primary-title {
  background-color: #FFD000;
  color: #2D2D2D;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  margin-bottom: 1.5rem;
  margin-top: 0;
}

.form-header h2 {
  font-size: 2rem;
  margin-bottom: 0.5rem;
  margin-top: 0;
  font-weight: bold;
  text-align: center;
}

.descripcion-diagnostico {
  margin: 0.1rem 4rem;
  text-align: justify;
  color: white;
}

.descripcion-diagnostico p {
  margin-bottom: 1rem;
  line-height: 1.6;
  color: white;
}

@media (max-width: 768px) {
  .descripcion-diagnostico {
    margin: 0.1rem 2rem;
  }
}

@media (max-width: 480px) {
  .descripcion-diagnostico {
    margin: 0.1rem 1rem;
    text-align: left;
  }
}

.pilares-analisis {
  background-color: #FFD000;
  padding: 1.5rem;
}

.pilares-analisis h3 {
  color: #2D2D2D;
  margin-bottom: 1rem;
  font-size: 1.6rem;
  text-align: center;
}

.pilares-analisis ul {
  list-style: none;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;
  margin: 0 4rem;
}

.pilares-analisis li {
  background: #F8F9FA;
  padding: 0.5rem;
  border-radius: 20px;
  border-left: 4px solid #FFC107;
  box-shadow: 0 6px 2px rgba(0, 0, 0, 0.1);
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

@media (max-width: 768px) {
  .pilares-analisis ul {
    margin: 0 2rem;
    gap: 1rem;
  }
}

@media (max-width: 480px) {
  .pilares-analisis ul {
    grid-template-columns: 1fr;
    margin: 0 1rem;
    gap: 1rem;
  }

  .pilares-analisis li {
    padding: 0.75rem;
  }
}

.pilares-analisis strong {
  display: block;
  font-size: 1.1rem;
}

/* Make the left content take remaining space so the percentage sits on the right */
.pilares-analisis li > div:first-child {
  flex: 1 1 auto;
}

.pilares-analisis .peso-categoria {
  font-size: 1.1rem;
  color: #FFD000;
  font-weight: 700;
  min-width: 48px;
  text-align: right;
  margin-left: 1rem;
}

.pilares-analisis p {
  margin: 0;
  color: #666;
  line-height: 1.4;
  font-size: 0.95rem;
}

/* Estilos para impresión/PDF */
@media print {
  .form-header {
    margin-bottom: 1rem;
    page-break-inside: avoid;
  }

  .form-header h2 {
    font-size: 1.5rem;
    margin-bottom: 0.8rem;
    color: #2c3e50;
  }

  .descripcion-diagnostico {
    margin: 0.5rem 0 1rem 0;
  }

  .descripcion-diagnostico p {
    display: block !important;
    font-size: 0.85rem;
    line-height: 1.5;
    margin-bottom: 0.6rem;
    text-align: justify;
  }

  .pilares-analisis {
    margin-top: 1rem;
    page-break-inside: avoid;
  }

  .pilares-analisis h3 {
    margin-bottom: 1rem;
    font-size: 1.2rem;
  }

  .pilares-analisis ul {
    gap: 0.8rem;
    grid-template-columns: 1fr;
  }

  .pilares-analisis li {
    padding: 1rem;
    margin-bottom: 0.5rem;
    page-break-inside: avoid;
    background: #f8f9fa !important;
    border-left: 4px solid #FFC107 !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 1rem;
  }

  .pilares-analisis li > div:first-child {
    flex: 1;
  }

  .pilares-analisis strong {
    display: block;
    margin-bottom: 0.5rem;
    font-size: 1rem;
  }

  .pilares-analisis .peso-categoria {
    font-size: 1.5rem;
    font-weight: bold;
    color: #0067b1 !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
    flex-shrink: 0;
    min-width: 50px;
    text-align: right;
  }

  .pilares-analisis p {
    font-size: 0.85rem;
    line-height: 1.4;
    margin: 0;
  }
}
</style>
/* Estilos para impresi�n/PDF */
@media print {
  .form-header {
    margin-bottom: 1rem;
    page-break-inside: avoid;
  }

  .form-header h2 {
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
    color: #2c3e50;
  }

  .descripcion-diagnostico {
    display: none !important;
  }

  .pilares-analisis {
    margin-top: 0.5rem;
    page-break-inside: avoid;
  }

  .pilares-analisis h3 {
    margin-bottom: 0.8rem;
    font-size: 1.2rem;
  }

  .pilares-analisis ul {
    gap: 0.5rem;
    grid-template-columns: 1fr;
  }

  .pilares-analisis li {
    padding: 0.8rem;
    page-break-inside: avoid;
    background: #f8f9fa !important;
    border-left: 4px solid #FFC107 !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .pilares-analisis strong {
    margin-bottom: 0.3rem;
    font-size: 1rem;
  }

  .pilares-analisis .peso-categoria {
    font-size: 1.2rem;
    color: #0067b1 !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .pilares-analisis p {
    font-size: 0.85rem;
    line-height: 1.3;
  }
}
